import styled from 'styled-components';
import { lighten } from 'polished';
import React from 'react';
import PropTypes from 'prop-types';

const SwitchChannel = styled.button`
    font-size: 12px;
    background: #fff;
    border: 1px solid ${props => props.theme.colors.primary};
    margin: 5px 2px 0 2px;
    outline: 0;

    :hover {
        background-color: ${props => lighten(0.59, props.theme.colors.primary)};
    }
`;

const SwitchChannelButton = ({ switchWorkOrderPlatforms, fieldKey, platform }) => {
    const switchPlatform = () => switchWorkOrderPlatforms({ fieldKey, deliveryPlatform: platform.value });

    return (
        <SwitchChannel type="button" onClick={switchPlatform}>
            {`All ${platform.text}`}
        </SwitchChannel>
    );
};

SwitchChannelButton.propTypes = {
    fieldKey: PropTypes.string,
    switchWorkOrderPlatforms: PropTypes.func,
    platforms: PropTypes.object
};

export default SwitchChannelButton;



// WEBPACK FOOTER //
// ./src/components/organisms/entity/edit/SwitchChannelButton.js